import { BigNumber, Contract, ethers } from "ethers";
import { ERC20Interface, useCall, useCalls, useContractFunction, useEthers } from "@usedapp/core";
import * as MasterAbi from "../abis/masterStakeContract.json"
import * as StakeAbi from "../abis/stakeContract.json"
import { Falsy } from "@usedapp/core/dist/esm/src/model/types";
import { useCoingeckoPrice } from "@usedapp/coingecko";
import { HERA_TOKEN } from "../constants/constrants";


export function useMasterStakeContactX(stakeContractAddr: string,) {
    const tokenContract = new Contract("0x4cDc2Cc903bb6129CEE5Dd69D2B34e5a1bE375B6", MasterAbi.abi);
    const {state, send, events} = useContractFunction(tokenContract, 'getDetails', {transactionName: "Detail Transaction"});
    
    return {state, send, events};
}

export function useStakeContractDetail(stakeContractAddr: string, account:string  | Falsy ): [BigNumber,number,number,number,number,string,number,number]{
    const calls =[
        stakeContractAddr && account  && {
            contract: new Contract(stakeContractAddr,  StakeAbi.abi), // instance of called contract
            method: "getUserInfo", // Method to be called
            args: [account], // Method arguments - address to be checked for balance
          },
          stakeContractAddr && account  &&  {
            contract: new Contract(stakeContractAddr, StakeAbi.abi), // instance of called contract
            method: "getDetails", // Method to be calledpendingReward
            args: [], // Method arguments - address to be checked for balance pendingReward
          },
          stakeContractAddr && account  &&  {
            contract: new Contract(stakeContractAddr, StakeAbi.abi), // instance of called contract
            method: "pendingReward", // Method to be calledpendingReward
            args: [account], // Method arguments - address to be checked for balance pendingReward
          },
          stakeContractAddr && account  &&  {
            contract: new Contract(HERA_TOKEN, ERC20Interface), // instance of called contract
            method: "balanceOf", // Method to be called
            args: [account], // Method arguments - address to be checked for balance pendingReward
          },

    ] ?? []
    let results = useCalls(calls) ?? []
    results.forEach((result, idx) => {
      if(result && result.error) {
        console.error(`Error encountered calling 'totalSupply' `)
      }
    })
    //results = results.map(result => result?.value)
    //console.log(results[2]?.value.toString())
    const stakedAmount = results[0]?.value[0] ?? BigNumber.from("0")
    const claimableAmount = Number(ethers.utils.formatEther(results[2]?.value[0] ?? BigNumber.from("0")))
    const balanceAmount = Number(ethers.utils.formatEther(results[3]?.value[0] ?? BigNumber.from("0")))
    const heraPrice = Number(useCoingeckoPrice("hera-finance", 'usd'))
    let tvl = Number(ethers.utils.formatEther(results[1]?.value[3] ?? BigNumber.from("0")))
    /*for (let i = 0; i < results[1]?.value.length; i++) {
        tvl += Number(ethers.utils.formatEther(results[1]?.value[i][1] ?? BigNumber.from("0"))) ;
    }*/
    //const etherPrice = useCoingeckoPrice('ethereum', 'usd')


  const userDepositTime = Number(results[0]?.value[2].toString())
  const userUpdateTime = Number(results[0]?.value[3].toString())

  const startTime = results[1]?.value[0]
  const finishTime = results[1]?.value[1]
  const rewardAmount = Number(ethers.utils.formatEther(results[1]?.value[2] ?? BigNumber.from("0")))
  const diffBlockNumber = Number(finishTime - startTime);
  const mulValue = Number(365 * 24 * 60 * 60 / diffBlockNumber);
  const mul = Number(mulValue);
  const pool = rewardAmount
  const all = tvl
  let APY = Number(((pool * mul) / all) * 100).toFixed(2);
  if(new Date().getTime() > results[1]?.value[1] * 1000)
    APY = "0"
    

    return [ stakedAmount ,claimableAmount,heraPrice, tvl, balanceAmount,APY, userDepositTime,finishTime]
}

export function useStakeContractDetailx(stakeContractAddr:string){
    const { account, deactivate } = useEthers();

    const { value, error } =
    useCall(
        {
          contract: new Contract(stakeContractAddr, StakeAbi.abi), // instance of called contract
          method: "getUserInfo", // Method to be called
          args: [account], // Method arguments - address to be checked for balance
        }
    ) ?? {};
  if(error) {
    console.error("eRROR",error.message)
    return undefined
  }
  /**
   * 
   * user.amount,
            user.rewardDebt,
            user.userPoolIds,
            user.stakeStartDate,
            user.igoUser
            const data = {
    apr: 84.11,
    staked: 9477,
    stakedUSDC: 27699,
    tvl: 2762699,
    tvlUSDC: 2762699,
    balance: 50,
    claimable: 50,
  };
   */
  console.log(value)
  if(value)
  return {
        staked:value[0],
        claimable:value[1],
    }
  else return {
    staked:0,
    claimable:0,
}
}


/*
{
      contract: "0x0",
      type: 1,
      isActive: true,
      isStaked: false,
      name: "Single Stake",
      tokenName: "HERA",
      imgUrl: "assets/images/icons/hera-hera.png",
    },
*/